/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Exercises_FailedInputs */

const en_us2_search_exercises_failed = /** @type {(inputs: Search_Exercises_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Could not search the exercises.`)
};

const pt_br2_search_exercises_failed = /** @type {(inputs: Search_Exercises_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível buscar os exercícios.`)
};

const es_419_search_exercises_failed = /** @type {(inputs: Search_Exercises_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudieron buscar los ejercicios.`)
};

const pt_pt2_search_exercises_failed = /** @type {(inputs: Search_Exercises_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível pesquisar os exercícios.`)
};

const fr_fr2_search_exercises_failed = /** @type {(inputs: Search_Exercises_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de rechercher les exercices.`)
};

const de_de2_search_exercises_failed = /** @type {(inputs: Search_Exercises_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Übungen konnten nicht durchsucht werden.`)
};

const it_it2_search_exercises_failed = /** @type {(inputs: Search_Exercises_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile cercare gli esercizi.`)
};

/**
* | output |
* | --- |
* | "Could not search the exercises." |
*
* @param {Search_Exercises_FailedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_exercises_failed = /** @type {((inputs?: Search_Exercises_FailedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Exercises_FailedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_exercises_failed(inputs)
	if (locale === "es-419") return es_419_search_exercises_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_search_exercises_failed(inputs)
	if (locale === "fr-FR") return fr_fr2_search_exercises_failed(inputs)
	if (locale === "de-DE") return de_de2_search_exercises_failed(inputs)
	if (locale === "it-IT") return it_it2_search_exercises_failed(inputs)
	return en_us2_search_exercises_failed(inputs)
});
export { search_exercises_failed as "search.exercises_failed" }